import commonJsModule from "sitemap-xml-webpack-plugin"

export default commonJsModule.default